export default {"src":"/_next/static/media/dreamcase_logo_black.8666bf1e.svg","height":130,"width":757};